// import PaymentRoutes from './Payment/router';
// import InvoiceRoutes from '@/modules/Donors/Invoice/router.js';

const Index = () => import( /* webpackChunkName: "donors" */ './index.vue');
const List = () => import( /* webpackChunkName: "donors" */ './view/CustomerList.vue');
const PaymentRequestList = () => import( /* webpackChunkName: "donors" */ '@/modules/Donors/PaymentInfoCollect/List.vue');
// const DeletedList = () => import( /* webpackChunkName: "donors" */ './view/DeletedCustomerList.vue');
const Profile = () => import( /* webpackChunkName: "donors" */ './view/Profile.vue');
// const Home = () => import(/* webpackChunkName: "donors" */ './view/Home.vue');



let routes = [];
// routes = routes.concat(PaymentRoutes);
// routes = routes.concat(InvoiceRoutes);

routes = routes.concat([{
    path: 'list',
    name: 'donors-list',
    component: List,
  },
  // {
  //   path: 'list',
  //   name: 'donors-list-payment',
  //   component: List,
  // },
  {
    path: 'paymentRequest/list',
    name: 'payment-request-list',
    component: PaymentRequestList,
  },
  {
    path: ':id/profile',
    name: 'donors-profile',
    component: Profile,
  },
]);

export default [{
  path: '/donors',
  redirect: {
    name: 'donors-list'
  },
  component: Index,
  children: routes,
}];